import salesforceMarketingCloud from '../../src/services/salesforceMarketingCloud';
import { getMessaging, onMessage, getToken as getMessageToken } from "firebase/messaging";
import { firebaseInitialize } from '../services/firebaseConfig';
import eventEmitter from '~/utils/eventEmitter';

const firebaseHandler = {
  getToken: async (store, roles) => {
    try {
      const messaging = getMessaging(firebaseInitialize);
      const vapidKey = process.env.REACT_APP_FIREBASE_VAPIDKEY;
      const permission = await Notification.requestPermission();

      if (permission === 'granted') {
        try {
          const currentToken = await getMessageToken(messaging, { vapidKey });
          if (currentToken) {
            firebaseHandler.setFirebasePushToken(currentToken, store, roles);

            onMessage(messaging, (payload) => {
              if (payload.notification) {
                eventEmitter.emit('newMessage', payload.notification.title, payload.notification.body);
              }
            });

            return currentToken;
          }
        } catch (tokenError) {
          console.error('Error getting the message token:', tokenError);
          return null;
        }
      } else {
        console.error('Notification permission denied');
        return null;
      }
    } catch (err) {
      console.error('Push token error:', err);
      return null;
    }
  },

  setFirebasePushToken: (newToken, store, roles) => {
    salesforceMarketingCloud.authMarketingCloud(newToken, store, roles);
  },
};

export default firebaseHandler;